import { render } from "./SignUpView.vue?vue&type=template&id=f0aac8ee&scoped=true"
import script from "./SignUpView.vue?vue&type=script&lang=js"
export * from "./SignUpView.vue?vue&type=script&lang=js"

import "./SignUpView.vue?vue&type=style&index=0&id=f0aac8ee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0aac8ee"]])

export default __exports__